const itemMainImageMixin = {

    methods: {

        getItemMainImage(item) {

            const images = JSON.parse(item.images);

            const defaultImage = {

                path: '/img/default_image.png',
                file_name: 'default.png',

            };

            let mainImage = defaultImage;

            if (images && Array.isArray(images)) {

                mainImage = images.find((img) => img.main == 1);

                // Si no encuentra imagen principal, pero si hay registradas imágenes
                if (!mainImage && images.length > 0) {

                    [mainImage] = images;

                }

                // Le concateno el root path a la imágen
                mainImage.path = this.fileRootPath + mainImage.path;

            }

            return mainImage;

        },

    },

};

export default itemMainImageMixin;
